<template>
  <div class="col-md mstabsdetails__content">
    <div class="mstabsdetails__content--title mb-3">CARRIER INFORMATION</div>
    <div v-for="(item, i) in detail.freightMode === 'AIR' ? dataAir : data" :key="i">
      <div v-if="item.show" class="row m-0 mstabsdetails__content--info mb-1">
        <div class="col-md-3 p-0">{{item.label}}</div>
        <div class="col-md p-0 blue" v-if="item.label !== 'Gross Weight' &&
        item.label !== 'Nett Weight'"><span class="mr-2">:</span>
          {{item.text || item.value ? item.text || item.value : '-'}}
        </div>
        <div class="col-md p-0 blue" v-else-if="item.label === 'Gross Weight' ||
          item.label === 'Nett Weight'"><span class="mr-2">:</span>
          {{getCurrency(item.value)}} Kg
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import mixinShipment from '@/mixin/getters/shipment-details'

export default {
  name: 'CarrierInformation',
  mixins: [mixinShipment],
  computed: {
    ...mapGetters({
      detail: 'shipment/item',
      isLoading: 'shipment/isLoading',
      isError: 'shipment/error',
      // update detail
      updated: 'shipment/isUpdated',
      isUpdating: 'shipment/isUpdating' // loading
    })
  },
  mounted () {
    this.init()
  },
  data: () => ({
    form: {},
    data: [
      { // 0
        label: 'Shipping Line',
        payloadVar: 'shippingLine',
        type: 'text',
        value: '',
        show: true,
      },
      { // 1 - VESSEL
        label: 'Vessel Type',
        payloadVar: 'freightType',
        type: 'text',
        value: '',
        show: false,
      },
      { // 2 - VESSEL
        label: 'Vessel Size',
        payloadVar: 'freightSubType',
        value: '',
        show: false,
      },
      { // 3 - VESSEL
        label: 'Vessel/Voyage Number',
        payloadVar: '',
        type: 'text',
        value: '',
        show: false,
      },
      { // 4
        label: 'Master Bill of Lading',
        payloadVar: 'masterBlAwb',
        type: 'text',
        value: '',
        show: true,
      },
      { // 5
        label: 'Master BL Type',
        payloadVar: 'masterBlAwbType',
        value: '',
        fieldDropdown: '',
        show: true,
      },
      { // 6
        label: 'House Bill of Lading',
        payloadVar: 'carrierBlAwb',
        type: 'text',
        value: '',
        disabled: true,
        show: true,
      },
      { // 7
        label: 'House BL Type',
        payloadVar: 'bl_type',
        value: '',
        fieldDropdown: '',
        show: true,
      },
      { // 8
        label: 'Terms',
        payloadVar: 'terms',
        value: '',
        text: '',
        fieldDropdown: '',
        show: true,
      },
      { // 9
        label: 'Gross Weight',
        payloadVar: 'gross_weight',
        type: 'number',
        value: '',
        show: true,
      },
      { // 10
        label: 'Nett Weight',
        payloadVar: 'nett_weight',
        type: 'number',
        value: '',
        show: true,
      }
    ],
    dataAir: [
      {
        label: 'Shipping Line',
        payloadVar: 'shippingLine',
        type: 'text',
        value: '',
        show: true,
      },
      {
        label: 'Master Airway Bill',
        payloadVar: 'masterBlAwb',
        type: 'text',
        value: '',
        show: true,
      },
      {
        label: 'House Airway Bill',
        payloadVar: 'carrierBlAwb',
        type: 'text',
        value: '',
        disabled: true,
        show: true,
      },
      {
        label: 'House Airway BL Type',
        payloadVar: 'bl_type',
        value: '',
        fieldDropdown: '',
        show: true,
      },
      {
        label: 'Terms',
        payloadVar: 'terms',
        value: '',
        text: '',
        fieldDropdown: '',
        show: true,
      },
      {
        label: 'Gross Weight',
        payloadVar: 'gross_weight',
        type: 'number',
        value: ''
      },
      {
        label: 'Nett Weight',
        payloadVar: 'nett_weight',
        type: 'number',
        value: '',
        show: true,
      }
    ]
  }),
  methods: {
    init () {
      this.data[0].value = this.detail.carrierName
      this.data[4].value = this.detail.masterBlAwb
      this.data[5].value = this.detail.masterBlAwbType
      this.data[5].fieldDropdown = this.detail.masterBlAwbType ? { name: this.detail.masterBlAwbType } : ''
      this.data[6].value = this.detail.carrierBlAwb
      this.data[7].value = this.detail.bl_type
      this.data[7].fieldDropdown = this.detail.bl_type ? { name: this.detail.bl_type } : ''
      this.data[8].value = this.detail.terms
      this.data[8].text = this.getTermsValue(this.detail.terms)
      this.data[8].fieldDropdown = this.detail.terms ? { name: this.getTermsValue(this.detail.terms) } : ''
      this.data[9].value = this.detail.gross_weight
      this.data[10].value = this.detail.nett_weight

      if (this.detail.freightType === 'LCT' || this.detail.freightType === 'BARGE') {
        this.data[0].label = 'Vessel Name'
        this.data[0].value = this.detail.freights[0].voyageName
        this.data[1].value = this.getShipmentType(this.detail.freightType)
        this.data[1].show = true
        this.data[2].value = this.detail.freightSubType
        this.data[2].show = true
        this.data[3].value = this.detail.freights[0].voyageNumber
        this.data[3].show = true
        this.data[9].show = false
        this.data[10].show = false
      }

      this.dataAir[0].value = this.detail.carrierName
      this.dataAir[1].value = this.detail.masterBlAwb
      this.dataAir[2].value = this.detail.carrierBlAwb
      this.dataAir[3].value = this.detail.bl_type
      this.dataAir[3].fieldDropdown = this.detail.bl_type ? { name: this.detail.bl_type } : ''
      this.dataAir[4].value = this.detail.terms
      this.dataAir[4].text = this.getTermsValue(this.detail.terms)
      this.dataAir[4].fieldDropdown = this.detail.terms ? { name: this.getTermsValue(this.detail.terms) } : ''
      this.dataAir[5].value = this.detail.gross_weight
      this.dataAir[6].value = this.detail.nett_weight
    },
    getCurrency (value) {
      let newValue = '-'
      if (value) {
        newValue = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return newValue
    },
    getTermsValue (params) {
      let terms = ''
      if (params === 'CY/CY') {
        terms = 'Container Yard / Container Yard'
      }
      if (params === 'CFS/CFS') {
        terms = 'Container Freight Station / Container Freight Station'
      }
      if (params === 'CY/FO') {
        terms = 'Container Yard / Free Out'
      }
      return terms
    }
  },
  watch: {
    detail (data) {
      if (data) {
        this.init()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/managementShipment/detail/tab-detail/CarrierInformation.vue